import React from 'react';
import { range } from 'lodash';
import { Skeleton, SkeletonItem } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { TileGrid } from '../../TileGrid/TileGrid';
import { ThemeMode, useProviderTheme } from '../../hooks/useProviderTheme';
import './SchoolLinksWidgetSkeleton.scss';

export const SchoolLinksWidgetSkeleton: React.FC = () => {
  const { t } = useTranslation();
  const theme = useProviderTheme();

  return (
    <TileGrid className="schoolLinksWidgetSkeleton">
      {range(6).map((_, index) => (
        <Skeleton
          key={index}
          className="courseTileSkeleton"
          aria-label={t('loading_content', { defaultValue: 'Inhalte werden geladen...' })}
        >
          <SkeletonItem
            shape="rectangle"
            className={classNames('linkTile', 'skeletonItem', {
              dark: theme.mode === ThemeMode.Dark,
            })}
          />
        </Skeleton>
      ))}
    </TileGrid>
  );
};
